<template>
  <div class="hello" style="background-color: #f6f6f6;">
    <div class="header">
      <div @click="backJump" style="color: #fff;padding-top: 10px;margin-left: 10px;">
        <span style="line-height: 30px;"><i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>返回</span>
      </div>
      <div class="clear"></div>
      <img src="../assets/topback.png" style="width: 50%;height: 75%;float: right;margin-top: -10px;" alt="">
      <div>
        <h2><span>缴</span>费账单</h2>
      </div>
    </div>
    <div class="center" style="position: relative;">
      <div class="center-top">
        <div class="up">
          <div class="bt">
            <img src="../assets/dian.png" >
            <span>电费</span>
          </div>
          <div style="border-bottom: 1px solid #dee1e5;height: 35px;">
            <span style="color: #8e8e8e;float: left;">{{text}}</span><span style="float: right;">
            <span style="font-size: 22px;" v-if="content.productId != 'dianbiao2022t1v1' || content.productId != 'dianbiao2022t1v2'">{{bhdy}}（kw/h）</span>
            <span style="font-size: 22px;" v-else>{{bhdy}}（元）</span>
          </span>
          </div>
          <div class="clear"></div>
          <div style="margin-top:15px">
            <span style="font-size: 12px;float: right;">{{rateText}}</span>
            <span style="font-size: 12px;float: right;">
							数据更新时间：{{date}}
						</span>
          </div>
          <div class="clear"></div>
<!--          <van-button style="float:right;background-color:#1989fa;width: 80px;height: 40px;font-size: 10px;margin-top:10px" type="primary" @click="againReload">刷新剩余</van-button>-->
        </div>
      </div>
      <van-overlay :show="show"><van-loading style="display: flex;align-items: center;justify-content: center;height: 100%">获取中...</van-loading></van-overlay>
      <div class="center_auto">
        <div class="zj">
          <div class="botder">
            <span class="left">识别编码信息</span><span class="right">{{content.houseHoldNumber}}</span>
          </div>
          <div style="height:80px;border-bottom:1px solid #DEE1E5;line-height:40px">
            <div><div class="left">住址信息</div><br><div>{{content.actName}}</div></div>

          </div>
          <!--					<div class="clear"></div>-->
          <!--					<div class="botder"><span class="left">缴费单位</span><span class="right">{{projectName}}</span></div>-->
        </div>

      </div>
      <div class="center_bottom">
        <div class="down">
          <p style="color: #0F72DD;">缴费金额</p>
          <div class="allin">
            <van-button type="info" @click="backchange(1)" :style="colorone" style="width: 40%;">100元</van-button>
            <van-button type="info" @click="backchange(2)" :style="colortwo" style="width: 40%;">200元</van-button>
            <van-button type="info" @click="backchange(3)" :style="colorthree" style="width: 40%;margin-top:30px">300元</van-button>
            <van-button type="info" @click="backchange(0)" :style="colorzero" style="width: 40%;margin-top:30px">自定义金额</van-button>
          </div>
          <div :style="inputmonenone">
            <van-field v-model="price" type="number" label="¥" />
          </div>
        </div>
      </div>
      <van-button type="primary" @click="goJump" style="width: 90%;margin: 30px auto;background-color: #2D86F6;height:50px;border-radius: 10px;font-size: 16pt;letter-spacing: 1px;" block>立即缴费</van-button>

    </div>
    <div class="foot">
      <div class="bot">
        <p style="color:#0f72dd">缴费服务</p>

        <div style="border-bottom:1px solid #8e8e8e;height: 70px;margin-top: 35px;">
          <img src="../assets/money.png" style="width:50px;float:left; height:50px;" alt="">
          <div style="margin-left: 60px;">
            <span>缴费记录</span>
            <button @click="element" style="border: none;width:80px;border-radius: 50px;background-color: #0f72dd;color:#fff;height:30px;line-height: 30px;float: right;margin-top: 10px;">进入</button>
            <p>可查询每笔缴费记录</p>
          </div>

        </div>
        <div>
          <img src="../assets/jil.png" style="width:50px;float:left; height:50px;" alt="">
          <div style="margin-left: 60px;">
            <span>用量记录</span>
            <button @click="balance" style="border: none;width:80px;border-radius: 50px;background-color: #0f72dd;color:#fff;height:30px;line-height: 30px;float: right;margin-top: 10px;">进入</button>
            <p>日报、周报、月报</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import jump from "../common/jump";

import { Toast } from 'vant';
import wx from 'weixin-js-sdk';
import { hybalance, orderAll, waterAll} from "../common/api/mentw";
export default {
  data() {
    return {
      colorone:{
        backgroundColor: '#2D86F6',height: '25pt',borderRadius: '5px',
      },
      colortwo:{
        backgroundColor: '#8e8e8e',height: '25pt',borderRadius: '5px',marginLeft: '50px',
      },
      colorthree:{
        backgroundColor: '#8e8e8e',height: '25pt',borderRadius: '5px',
      },
      colorzero:{
        backgroundColor: '#8e8e8e',height: '25pt',borderRadius: '5px',marginLeft: '50px',
      },
      inputmonenone:{display:'none',marginTop: '30px',height: '26px',borderBottom: '1px solid #dee1e5'},
      price: 100,
      devId: "",
      houseHoldNumber: '',
      projectId: 1,
      payType: 1,
      show:false,
      error:'',
      phone: "",
      devAddress: "",
      mchId: "1",
      useType: 1,
      text:'剩余金额：',
      typ:'00',
      mchNumber: "",
      date:'',
      bhdy:'',
      content:'',
      number:'',
      math:'',
      ratePrice:'',
      rateText:''
    };
  },
  mounted() {
    waterAll({houseHoldNumber : this.$route.query.phone}).then((response)=>{
      this.content = response.data.items[0]
        hybalance({devId : this.content.devId,isRefurbish : false}).then((response) =>{
          if(response.code == 200){
            this.text = "剩余电量："
            this.bhdy = response.data.surplusElectricQuantity
            this.date = response.data.time
            this.ratePrice = response.data.ratePrice
            this.rateText = "单价："+response.data.ratePrice+"（元）/kwh"
          }else{
            this.$toast.fail(response.msg)
          }

        })
        return
    })
  },
  methods:{
    backJump(){
      this.$destroy()
      jump.$emit('back')
      this.$router.go(-1)
    },
    goJump() {
      if(this.content.productId != 'dianbiao2022t1v1' || this.content.productId != 'dianbiao2022t1v2'){
        if(Number(this.price) < Number(this.ratePrice)){
          this.$toast.fail('充值金额不得低于单价')
          return
        }
      }
      var data = {
        "price": this.price,
        "devId": this.content.devId,
        "houseHoldNumber": this.content.houseHoldNumber,
        "payType": this.payType,
        "phone": this.content.phone,
        "devAddress": this.content.actName,
        "useType": 1,
        "mchName": this.content.mchName,
        "mchNumber": this.content.mchNumber,
        "type": this.content.devType,
        "tenantId": this.content.tenantId,
        "productId":this.content.productId,
        "payment":this.content.payType
      };

      if (this.content.productId == "dianbiao2022hyv1") {
        let price =parseFloat(this.price / this.ratePrice).toFixed(1) -0;
        this.$set(data, 'amount', price)
      }
      data = JSON.stringify(data)
      orderAll(data).then((reson) => {
        this.jsap(reson.data.orderNo,this.content.devType,reson.data.partnerCode,reson.data.storeId)
          })
    .catch(function (error) {
      });
    },
    element(){
      this.$router.push({path:'/element',query:{houseHold:this.content.houseHoldNumber}})
    },
    jsap(orderNo,devType,partnerCode,storeId){
      let that = this
		console.log(window.__wxjs_environment)
      this.typ = window.__wxjs_environment
      var isWxMini = window.__wxjs_environment === 'miniprogram'     // 判断场景是否小程序
	  console.log(isWxMini)
      const url = '/pages/extPay/index?orderNo='+orderNo +'&token=' + this.$cookies.get("token") + '&devType=' + devType + '&partnerCode=' + partnerCode + '&storeId=' + storeId 
      if (isWxMini) {
        this.typ = "11跳转"
        wx.miniProgram.navigateTo({
          url: url,
          events:{
            paySuccess: function(payData){
              that.$toast.success('支付成功!')
            }
          }
        });
      } else {
        this.$toast('请在微信端重新操作')
      }
    },
    againReload(){
      this.show = true
        hybalance({devId : this.content.devId,isRefurbish : true}).then((response) =>{
          this.text = "剩余电量："
          this.bhdy = response.data.surplusElectricQuantity
          this.date = response.data.time
          this.show = false
          Toast.success('获取成功');
        }).catch(res =>{
          this.show = false
          this.$toast.fail(res.msg);
        })
    },
    balance(){
      this.$router.push({path:'/balance',query:{houseHold:this.content.houseHoldNumber,address:this.content.actName,text:this.text,balance:this.bhdy}})
    },
    backchange(much){
      switch (much){
        case 1:
          console.log(1)
          this.colorone.backgroundColor='#2D86F6',
              this.colortwo.backgroundColor='#8e8e8e',
              this.colorthree.backgroundColor='#8e8e8e',
              this.colorzero.backgroundColor='#8e8e8e',
              this.inputmonenone.display='none'

          this.price = 100
          break;
        case 2:
          console.log(2)
          this.colorone.backgroundColor='#8e8e8e',
              this.colortwo.backgroundColor='#2D86F6',
              this.colorthree.backgroundColor='#8e8e8e',
              this.colorzero.backgroundColor='#8e8e8e',
              this.inputmonenone.display='none'

          this.price = 200
          break;
        case 3:
          console.log(3)
          this.colorone.backgroundColor='#8e8e8e',
              this.colortwo.backgroundColor='#8e8e8e',
              this.colorthree.backgroundColor='#2D86F6',
              this.colorzero.backgroundColor='#8e8e8e',
              this.inputmonenone.display='none'

          this.price = 300
          break;
        case 0:
          console.log(0)
          this.colorone.backgroundColor='#8e8e8e',
              this.colortwo.backgroundColor='#8e8e8e',
              this.colorthree.backgroundColor='#8e8e8e',
              this.colorzero.backgroundColor='#2D86F6',
              this.inputmonenone.display='block'

          this.price =""
          break;
      }

    },
  },

};
</script>

<style scoped>
.clear{
  clear: both;
}
.header{
  width: 100%;
  height: 192px;
  background-color: #295ad0;
}

.header h2{
  letter-spacing:2px;
  color: rgb(255, 255, 255);
  line-height: 70px;
  position: relative;
  margin-left:20px
}
.header h2 span{
  border-bottom: 3px solid #fff;
}
.bt{
  height: 100px;
  margin-top:20px
}

.bt img{
  width: 38px;
  height:38px;
  float: left;
}
.bt span{
  line-height: 42px;
  margin-left: 10px;
  font-size: 20px;
}
.bt p {
  color:#0F72DD;
}
.center-top{
  width: 90%;
  margin: 0 auto;
  border: 1px solid #dee1e5;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  margin-top: -15px;
  background-color: #fff;
}
.up{
  width: 80%;
  margin: 0 auto;
  height: 250px;
}
.center_auto{
  width: 90%;
  margin: 0 auto;
  border: 1px solid #dee1e5;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  background-color: #fff;
  margin-top: 30px;
}
.zj{
  width: 80%;
  margin: 0 auto;
  height: 200px;
  margin-top: 20px;
}
.zj .botder{
  height: 55px;
  border-bottom:1px solid #DEE1E5;
  line-height: 55px;
}

.left{
  float: left;
  color: #8e8e8e;
}
.right{
  float: right;
}
.center_bottom{
  width: 90%;
  margin: 0 auto;
  border: 1px solid #dee1e5;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  margin-top: -15px;
  background-color: #fff;
  margin-top: 30px;
}
.down{
  width: 80%;
  margin: 0 auto;
  height: 230px;
  margin-top: 20px;
}
.down van-button{
  width: 30%;
}
.allin button{
  border: none;
}
.foot{
  width: 90%;
  border: 1px solid #dee1e5;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  height:260px;
  margin: 0 auto;
  margin-top:30px;
  background-color: #fff;
}
.bot{
  width: 80%;
  margin: 0 auto;
  padding-top: 10px;
}
.bot div{
  margin-top:20px
}
.bot div p{
  font-size: 14px;
  color: #8e8e8e;
  font-family: 'PingFangSC-Medium';
  margin-top: 5px;
}
</style>
